<div class="container-fluid">
    <app-page-header [header]="title" />
    <div class="row px-5">
        <div class="col-md-6 py-5">
            <img src="/assets/images/technical-arab.png" class="w-100" alt="Laptop Image" />
        </div>
        <div class="col-md-6  mt-2 objectives px-5">
            <h3> {{ "technicalCommittee.objectives" | translate }}</h3>
            <div class="container ">

                <p class="p-circle">
                    {{ "technicalCommittee.raisingAwareness" | translate }}

                </p>

                <p class="p-circle">
                    {{ "technicalCommittee.organizingStudies" | translate }}

                </p>

                <p class="p-circle">
                    {{"technicalCommittee.encouragingTheTransformation" | translate }}

                </p>
                <p class="p-circle">
                    {{ "technicalCommittee.findingMechanism" | translate }}

                </p>

                <p class="p-circle">
                    {{ "technicalCommittee.providingLegal" | translate }}

                </p>

                <p class="p-circle">
                    {{ "technicalCommittee.workToHarmonize" | translate }}

                </p>
                <p class="p-circle">
                    {{ "technicalCommittee.toPromoteTheCooperation" | translate }}


                </p>

                <p class="p-circle">
                    {{ "technicalCommittee.cooperatingWithArab" | translate }}


                </p>

            </div>
        </div>
    </div>

    

    <div class="row  text-center mt-5 membership">
        <div class="col-md-6  p-4 info-box mt-5">
            <img src="/assets/images/membership.png" alt="Membership">
            <h2 class="mt-3 fw-bold text-primary">{{ "technicalCommittee.membership" | translate }} </h2>
            <h5 class="fw-bold text-secondary">{{ "technicalCommittee.leagueMembership" | translate }}</h5>
            <div class="row mt-4">
                <div class=" col-md-4 col-sm-12 mt-4 " [ngClass]="{ 'borders': !isArabic}">
                    <h6 class="text-secondary">{{ "technicalCommittee.arabInsuranceBrokers" | translate }}</h6>
                </div>
                <div class=" col-md-4 col-sm-12  mt-4 borders">
                    <h6 class="text-secondary">{{ "technicalCommittee.arabCompanies" | translate }}</h6>
                </div>
                <div class=" col-md-4 col-sm-12 mt-4" [ngClass]="{ 'borders': isArabic}">
                    <h6 class="text-secondary">{{ "technicalCommittee.individualInsuranceBrokers" | translate }}</h6>
                </div>
            </div>
        </div>

        <div class="col-md-6 p-4 info-box mt-5">
            <img src="/assets/images/voting-rights.png" alt="Subscription Fee">
            <h2 class="mt-3 fw-bold text-primary mt-4">{{ "technicalCommittee.votingRights" | translate }}</h2>

            <h6 class="text-secondary mt-5">{{ "technicalCommittee.eachCountryHas" | translate }}</h6>

        </div>

        <div class="col-md-6  p-4 info-box mt-5">
            <img src="/assets/images/subscription.png" alt="Chairing the Meetings">
            <h2 class="mt-3 fw-bold text-primary">{{ "technicalCommittee.subscription" | translate }}</h2>
            <p class="text-secondary">{{ "technicalCommittee.annualSubscription" | translate }}</p>
        </div>

        <div class="col-md-6  p-4 info-box mt-5">
            <img src="/assets/images/chairing.png" alt="Chairing the Meetings">
            <h2 class="mt-3 fw-bold text-primary">{{ "technicalCommittee.chairing" | translate }}</h2>
            <h5 class="text-secondary">{{ "technicalCommittee.thePresidentBroker" | translate }} </h5>
            <h5 class="text-secondary"> {{ "technicalCommittee.presides" | translate }}</h5>
            <h5 class="text-secondary">{{ "technicalCommittee.inTheEvent" | translate }} </h5>
            <h5 class="text-secondary">{{ "technicalCommittee.theVicePresident" | translate }}</h5>

        </div>
    </div>




    <div class=" mt-0  p-5">
        <div class="row  p-5">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="text-primary text-start fw-bold">
                        {{ "technicalCommittee.leaguesOrgans" | translate}}
                    </h1>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-6 mt-4 p-4">
                    <img src="/assets/images/general-assembly.png" class="img-fluid rounded"
                        alt="General Assembly Image">
                </div>

                <div class="col-md-6 text-start mt-4">
                    <h3 class="text-primary fw-bold ">
                        {{ "technicalCommittee.associationSecretariat" | translate}}
                    </h3>
                    <h5 class=" mt-4"> {{ "technicalCommittee.gAIFSecretariat" | translate }} </h5>
                    <div class="container mt-4">
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.invitationToHold" | translate }}
                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.preparingAndOrganizing" | translate }}
                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.preparingMeeting" | translate }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row  p-5">
            <div class="row ">
                <div class="col-md-6 text-start mt-4">
                    <h3 class="text-primary fw-bold"> {{ "technicalCommittee.governingBodyLeague" | translate }}
                    </h3>
                    <h5 class=" fw-bold mt-4"> {{ "technicalCommittee.theLeaguesTemporary" | translate }} </h5>
                     
                    <div class="container ">
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.temporaryAdministrativeBody" | translate }}
                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.administrativeBoardElectAmong" | translate }}
                        </p>
                        <h5 class=" fw-bold mt-4"> {{ "technicalCommittee.WhenTheMembership" | translate }} </h5>
                        <p class="p-checkMarck mt-4">
                            {{ "technicalCommittee.gAIFSecretaryGeneral" | translate }}
                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.LeagueAdministrativeBody" | translate }}
                        </p>


                    </div>
                </div>
                <div class="col-md-6 mt-4 p-4">
                    <img src="/assets/images/association-secretariat.png" class="img-fluid rounded"
                        alt="General Assembly Image">
                </div>

            </div>
        </div>

        <div class="row  p-5">
            <div class="row ">
                <div class="col-md-6 p-4">
                    <img src="/assets/images/governing-body-association.png" class="img-fluid rounded"
                        alt="General Assembly Image">
                </div>
                <div class="col-md-6 text-start mt-4">
                    <h3 class="text-primary fw-bold"> {{ "technicalCommittee.thePrerogatives" | translate }}

                    </h3>
                    <div class="container mt-4">
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.preparingTheLeague" | translate }}

                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.formingSubCommitteesSpecific" | translate }}

                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.preparingAnnualReport" | translate }}

                        </p>


                    </div>
                </div>
            </div>
        </div>

        <div class="row  p-5">
            <div class="row ">
                <div class="col-md-6 text-start mt-4">
                    <h3 class=""> {{ "technicalCommittee.LeagueMeetings" | translate }}

                    </h3>
                    <div class="container mt-4">
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.theLeagueHolds" | translate }}
                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.meetingsYear" | translate }}
                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.theInvitationHold" | translate }}
                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.theGAIFSecretaryGeneral" | translate }}
                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.theQuorumRequired" | translate }}
                        </p>
                        <p class="p-checkMarck">
                            {{ "technicalCommittee.meetingMinutesAdministrative" | translate }}
                        </p>
                    </div>

                </div>
                <div class="col-md-6 mt-4 p-4">
                    <img src="/assets/images/milistone-image.png" class="img-fluid rounded"
                        alt="General Assembly Image">
                </div>
            </div>
        </div>
    </div>

    <div class="members-arab-insurance mt-0  p-5">
        <div class="row p-5">
            <div class="col-12 col-md-6  pl-5 pr-5" *ngFor="let item of achievementList">
                <div class="card mi-card text-light pt-5  mt-3 text-start">
                    <h3 class="fw-bold px-5">{{ isArabic? item.leagueAchievementTitleAr : item.leagueAchievementTitleEn
                        }}</h3>
                    <h4 class="px-5">{{isArabic ?item.descriptionAr :item.descriptionEn}}</h4>
                    <p class="p-circle position-absolute bottom-0 order-2"
                        [ngClass]="{'mi-download-en': !isArabic, 'mi-download-ar':isArabic}">
                        <span class="pointer" (click)="downloadAttachedPDF(item)">
                            <span class="text-decoration-underline fw-bold">
                                {{ "technicalCommittee.insuranceBrokers" | translate }} </span>
                            <img src="assets/svg/download-mi.svg" alt="download-icon" srcset="" class="mx-2" />
                        </span>
                    </p>
                </div>
            </div>

            <!-- Start Subscription Card -->
            <div class="col-12 col-md-6 pl-5 pr-5">
                <div class="subscription-card text-light pt-5 mt-3 text-center">
                    <h3 class="fw-bold px-5  mb-3">{{"technicalCommittee.joinTheLeague" | translate }}</h3>
                    <h4 class="px-5">{{"technicalCommittee.joinTheLeagueDescription" | translate }}</h4>
                    <button class="btn btn-primary" (click)="subscribe()">
                        {{"technicalCommittee.subscribe" | translate }}
                    </button>
                </div>
            </div>
            <!-- End Subscription Card -->
        </div>
    </div>
</div>

<div class="row p-0 m-0 mt-5 ">
    <div class="bg-blue py-3 mt-5 px-5 mb-5">
        <div class="container my-5">
            <h1 class="fw-bold text-center line-before border-primary border-3">
                {{ "technicalCommittee.temporaryOrganizationMember" | translate }}
            </h1>
            <div class="table-responsive">
                <table class="table custom-table text-light">
                    <thead>
                        <tr>
                            <th>{{ "technicalCommittee.name" | translate }}</th>
                            <th>{{ "technicalCommittee.title" | translate }}</th>
                            <th>{{ "technicalCommittee.country" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of memberList">
                            <td><span>{{isArabic? item.memberNameAr: item.memberNameEn}}</span></td>
                            <td>
                                <span>{{
                                  isArabic ? item.positionAr : item.positionEn
                                  }}</span>
                              </td>
                            <td><span>{{isArabic? item.countryNameAr: item.countryNameEn}}</span></td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<div class="container mt-5">
    <h2 class="mb-4">{{ "technicalCommittee.associationNews" | translate }} </h2>
    <div class="row">
        <div class="col-md-4 mb-4" *ngFor="let item of newsList">
            <app-technical-committee-news-card [news]="item" />


            <!-- <div class="card news-card">
                <div class="text-center photo-hight-display">
                    <img [src]="'https://via.placeholder.com/500x400.jpg'" class="card-image rounded-3 card-img-top"
                        alt="" [appDownloadImage]="item.imageFullPath" width="85%" />
                </div>
                <div class="card-body news-card-body">
                    <h6 class="card-title fw-bold">{{item.title}}</h6>
                    <p class="card-body-text">{{item.body}}</p>
                    <p class="card-text">
                        <small class="text-muted">{{item.day}} {{ item.month | customDate:'MMM' : "en-US" : isArabic}},
                            {{item.year | customDate:'yyyy' : "en-US" : isArabic}}</small>
                    </p>
                    <a (click)="downloadAttachedNewsPDF(item)" class="btn read-more-btn">{{ "homePage.seeMore" |
                        translate }}</a>
                </div>
            </div> -->
        </div>
    </div>
</div>